// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"f301329e","425":"f301329e","744":"d64eaba6"}[chunkId] + ".chunk.css";
};